module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jvxuey/tc-custom/9781614234258.jpg?1705025964647",
      "alt": "This image is the cover for the book Hanging Ruth Blay"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hanging Ruth Blay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The true story of a woman hanged in colonial Portsmouth for burying her stillborn out-of-wedlock baby.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" On a cold December morning in 1768, thirty-one-year-old Ruth Blay approached the gallows for her execution. Standing on the high ground in the northwest corner of what is now Portsmouth’s old South Cemetery, she would have had a clear view across the pasture to the harbor and open sea."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" The eighteenth-century hanging of a schoolteacher for concealing the birth of a child out of wedlock has appeared in local legend over the last few centuries, but the full account of Ruth’s story has never been told. Drawing on over two years of investigative research, author Carolyn Marvin brings to light the dramatic details of Ruth’s life and the cruel injustice of colonial Portsmouth’s moral code. As Marvin uncovers the real flesh-and-blood woman who suffered the ultimate punishment, her readers come to understand Ruth as an individual and a woman of her time.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolyn Marvin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carolyn Marvin currently works as a research librarian at the Portsmouth Athenaeum in Portsmouth, New Hampshire, where she first came upon the story of Ruth Blay. Previously, she worked in both public and school libraries. Ms. Marvin lives in a tiny ivy-covered brick house in the Atlantic Heights Historic District of Portsmouth with her granddaughter Makenzie, three cats, Dante the Westie, three hamsters and two fish.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0